import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import * as axios from 'axios';

export default {
    obterAcessoriosAsync,
    enviarAcessorioAsync,
    editarAcessorioAsync,
    downloadLista
}

export const obterAcessoriosAsync = async() => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Acessorio/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarAcessorioAsync = async(descricao, observacao) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ descricao, observacao })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Acessorio`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const enviarAcessoriosAsync = async(acessorios) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify(acessorios, replacer)
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Acessorio`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const editarAcessorioAsync = async(id, descricao, observacao, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, descricao, observacao, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Acessorio/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export function downloadLista() {
    try {
        return axios({
                url: `${process.env.VUE_APP_ROOT_API}/Acessorio/downloadAcessorios`,
                method: 'GET',
                responseType: 'blob',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
            }).catch(() => {
                return { status: false };
            })
            .then((response) => {
                if (response.status === false)
                    return response;
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'acessorios' + '.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            });
    } catch (e) {
        throw e;
    }
}

function replacer(key, value) {
    if (key == "index") return undefined;
    else return value;
}